<template>
    <div class="drawDetail">
        <div class="con flex jb ">
            <img src="./img/close.png"
                 @click="back"
                 class="close" />
            <div class="big_img">
                <el-image fit="contain"
                          @click.prevent="clickImage(square_data.raw_img_url)"
                          :src="square_data.img_url"
                          :preview-src-list="[square_data.raw_img_url]"
                          placeholder
                          v-if="img_type"
                >

                </el-image>
            </div>
            <div class="text_area">
                <div class="user flex jb ac">
                    <div class="info flex  ac">
                        <div class="avatar">
                            <img src="@/views/objIcon/MJ.png"
                                 alt=" " />
                        </div>
                        <div class="name">
                            <p class="nickname">白日梦</p>
                            <p class="flex ac"><img src="./img/icon_img50.png" style="color: #FC8C0A;"
                                     alt=" " /><span>{{square_data.views}}</span><img src="./img/icon_img51.png"
                                     alt=" " /><span>{{square_data.votes}}</span></p>
                        </div>
                    </div>
                    <div class="fav flex jc ac" @click="handleVote">
                        <img src="./img/icon_img51.png"
                             alt=" " />
                        <p>点赞</p>
                    </div>
                </div>
                <div class="item">
                    <div class="title flex jb ac">
                        <p>提示词</p>
                        <p class="flex ac" v-clipboard:copy="square_data.prompt" v-clipboard:success="copySuccess" v-clipboard:error="copyError"><img src="./img/icon_img52.png"  alt=" " /><span>复制</span></p>
                    </div>
                    <div class="desc">
                        {{ square_data.prompt }}
                    </div>
                </div>
                <div class="item">
                    <div class="title flex jb ac">
                        <p>英文</p>
                        <p class="flex ac" v-clipboard:copy="square_data.prompt_en" v-clipboard:success="copySuccess"
                                    v-clipboard:error="copyError"><img src="./img/icon_img52.png"
                                 alt=" " /><span>复制</span></p>
                    </div>
                    <div class="desc">
                        {{ square_data.prompt_en }}
                    </div>
                </div>
                <div class="item">
                    <div class="title flex jb ac">
                        <p>参数信息</p>
                    </div>
                    <div class="desc">
                        <div class="params_item flex ac">
                            <p class="title">绘制模型</p>
                            <p class="tips">{{square_data.img_model}}</p>
                        </div>
                        <div class="params_item flex ac">
                            <p class="title">图片比例</p>
                            <p class="tips">{{square_data.aspect}}</p>
                        </div>
                        <div class="params_item flex ac">
                            <p class="title">图片尺寸</p>
                            <p class="tips">{{square_data.width}}:{{ square_data.height }}</p>
                        </div>
                        <div class="params_item flex ac">
                            <p class="title">高级参数</p>
                            <p class="tips">{{square_data.parameters}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            draw_id: this.$route.query.draw_id || 0,
            square_data: {},
            is_vote:0,
          img_type:false,
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            //发送请求
            this.$http.get(`/front/aimj/user/draw/${this.draw_id}/`).then((res) => {


                this.square_data = res.data
                this.img_type = true

            })
        },
        back () {
            this.$router.go(-1)
        },
        handleVote(){
            this.$http.patch(`/front/aimj/draw/${this.draw_id}/`,{action:'vote'}).then((res) => {
                if(this.is_vote){
                    this.is_vote = 0
                    this.square_data.votes = this.square_data.votes - 1
                }else{
                    this.is_vote = 1
                    this.square_data.votes = this.square_data.votes + 1
                }
            })
        },
        copySuccess() {
            this.$message.success('复制成功！');
        },
        copyError() {
            this.$message.error('复制失败！');
        },
        clickImage (raw_img_url) {
            // 下载图片
            this.$nextTick(() => {
                let wrapper = document.getElementsByClassName(
                    "el-image-viewer__actions__inner"
                );
                let downImg = document.createElement("i");
                downImg.setAttribute("class", "el-icon-download");
                wrapper[0].appendChild(downImg);
                if (wrapper.length > 0) {
                    const wrapperElem = wrapper[0];
                    downImg.addEventListener("click", () => {
                        this.$message.success('已为您下载图片，如下载失败，请右键保存或长按保存图片');
                        var image = new Image();
                        // 解决跨域 Canvas 污染问题
                        image.setAttribute("crossOrigin", "anonymous");
                        image.onload = function () {
                            var canvas = document.createElement("canvas");
                            canvas.width = image.width;
                            canvas.height = image.height;
                            var context = canvas.getContext("2d");
                            context.drawImage(image, 0, 0, image.width, image.height);
                            var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

                            var a = document.createElement("a"); // 生成一个a元素
                            var event = new MouseEvent("click"); // 创建一个单击事件
                            a.download = Date.now(); // 设置图片名称
                            a.href = url; // 将生成的URL设置为a.href属性
                            a.dispatchEvent(event); // 触发a的单击事件
                        };
                        image.src = raw_img_url;
                    });
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
div{
  box-sizing: border-box;

}
.drawDetail {
    background: #1e1f22;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .con {
        width: 1000px;
        padding: 32px;
        background: #303237;
        border-radius: 15px;
        position: relative;
        .close {
            position: absolute;
            right: -70px;
            top: 0;
            width: 48px;
            height: 48px;
            cursor: pointer;
            opacity: 0.4;
        }
        .big_img {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 450px;
            height: 600px;
            max-width: 100%;
            max-height: 100%;
            padding: 0 30px 0 0;
          box-sizing: border-box;
            .el-image {
                width: 100%;
                height: 100%;
            }
        }
        .text_area {
width: 480px;
//          padding-right: 30px;
            .user {
                margin-bottom: 34px;
                .info {
                    .avatar {
                        width: 46px;
                        height: 46px;
                        background: #acacac;
                        border-radius: 100%;
                        overflow: hidden;
                        margin-right: 10px;
                        img {
                            width: 100%;
                        }
                    }
                    .name {
                        p {
                            img {
                                width: 16px;
                                height: 16px;
                                opacity: 0.5;
                            }
                            span {
                                margin-left: 5px;
                                margin-right: 10px;
                                font-size: 12px;
                                color: #999;
                                position: relative;
                                top: 2px;
                            }
                        }
                        .nickname {
                            font-size: 14px;
                            color: #fff;
                            margin-bottom: 5px;
                        }
                    }
                }
                .fav {
                    width: 80px;
                    height: 40px;
                    border-radius: 40px;
                    background: #474858;
                    cursor: pointer;
                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 5px;
                    }
                    p {
                        font-size: 12px;
                        color: #fff;
                    }
                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
            .item {
              width: 100%;
                margin-top: 10px;
                .title {
                    p {
                        font-size: 14px;
                        color: #fff;
                    }

                    img {
                        width: 24px;
                        height: 24px;
                        opacity: 0.7;
                    }
                    span {
                        font-size: 12px;
                        color: #999;
                    }
                    .flex {
                        cursor: pointer;
                        &:hover {
                            img {
                                opacity: 1;
                            }
                            span {
                                color: #fff;
                            }
                        }
                    }
                }
                .desc {
                  width: 100%;
                    background-color: #262626;
                    color: #fff;
                    padding: 16px;
                  height: auto;
                    //min-height: 60px;
                    //max-height: auto;
                    border-radius: 10px;
                    line-height: 1.7;
                    margin-top: 10px;
                  ;
                    .params_item {
                        padding: 5px 0;
                        .title {
                          //width: 100px;
                            color: #949ba4;
                            margin-right: 10px;
                        }
                        .tips {
                          flex: 1;
                          color: #fff;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        }
                    }
                }
            }
        }
    }
}
</style>